/** PRODUCTION LINK */
const baseUrlTrimitraCatalog = "https://zvu1c5uoue.execute-api.ap-southeast-1.amazonaws.com/v1";
const baseUrlAmartaVip = "https://3krjkubmjk.execute-api.ap-southeast-3.amazonaws.com/v1";
const baseUrlCdnUpload = "https://hbxhwzeej9.execute-api.ap-southeast-1.amazonaws.com/v1";
// const baseUrlAutotrimitra = "https://au-api-trimitra-get-65q45htc.ts.gateway.dev";
const baseUrlAutotrimitra = "https://ynxhhkiw7e.execute-api.ap-southeast-3.amazonaws.com/v1";
const baseUrlPromo = "https://80pj23grqd.execute-api.ap-southeast-1.amazonaws.com/v1";
const baseUrlOffer = "https://42cjbxpaa8.execute-api.ap-southeast-1.amazonaws.com/v1";
const baseUrlTrack = "https://w7ycz3l377.execute-api.ap-southeast-1.amazonaws.com/v1";

const baseUrlIdealTrimitra = "https://asia-southeast2-ideal-trimitra.cloudfunctions.net/ideal-backend";
const baseUrlB2b = "https://b2b-backend-281477335834.asia-southeast2.run.app";
const baseUrlBigQuery = "https://asia-southeast1-autotrimitra.cloudfunctions.net/invento-serverless-bridging__big-query";

/** KEY */
const xApiKeyTrimitraCatalog = '5ukoYcllpl6lIeKsbeIPI4hOZGDszFVk1dDBddHi';
const xApiKeyAmartaVip = 'wbEBxCen12pHWwBHMakz3ebKWmttdwr9BfYrZlw2';
const xApiKeyCdnUpload = 'zXSa4iZwycS0O5kaoMvi2yAFiIpimTZ55MvvJLy0';
const xApiKeyPromo = 'itMzx2LEJU2VtfzkBsZXs7U4p2ScXXXn4qY3Xdbw';
const xApiKeyOffer = '9bekwohY878MgiMsRL0Wk2Xsgv4QsxtW4jEIuBqb';
const xApiKeyTrack = '92b53lWKwg1mu2sRDumFl5Q158DQjbRh8XlH8VX0';
const xApiKeyBigQuery = 'f2455606-8b41-11ed-a1eb-0242ac120002';

export {
    baseUrlBigQuery, xApiKeyBigQuery, baseUrlTrack, xApiKeyTrack, baseUrlAmartaVip, baseUrlB2b, xApiKeyAmartaVip, baseUrlCdnUpload, xApiKeyCdnUpload, baseUrlTrimitraCatalog, xApiKeyTrimitraCatalog, baseUrlAutotrimitra, baseUrlPromo, xApiKeyPromo, baseUrlOffer, xApiKeyOffer, baseUrlIdealTrimitra
}